import { render, staticRenderFns } from "./MyClassrooms.vue?vue&type=template&id=3b4a4868&"
import script from "./MyClassrooms.vue?vue&type=script&lang=js&"
export * from "./MyClassrooms.vue?vue&type=script&lang=js&"
import style0 from "./MyClassrooms.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports